import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { css, cx } from "@emotion/css";
import { camelCase } from "lodash";
import { Text } from "../../text";
import { Box } from "../../box";
import { Icon } from "../../icon";
import { FlagIcon } from "../../flag-icon";
import { useBlockComponentContext } from "../../form-blocks";
export const SlideRow = ({ index, translationKey, active, hasFlags, onClick, }) => {
    const { Translated, translate } = useBlockComponentContext();
    return (_jsx("div", { onClick: () => onClick(index), className: s.container, children: _jsxs(Box, { flexDirection: "row", alignItems: "center", justifyContent: "space-between", className: "sliderow-0-47", children: [_jsxs(Box, { flexDirection: "row", className: cx(s.titleContainer, { active }), children: [active && (_jsx("div", { className: "sliderow-0-46", children: _jsx(Icon, { name: "sort-down", color: "#007bcd", size: 14 }) })), _jsx(Text, { className: s.title, fontSize: "1.25em", "data-test-id": "sliderow-" + camelCase(translate(translationKey)), children: _jsx(Translated, { translationKey: translationKey }) })] }), hasFlags && _jsx(FlagIcon, {})] }) }));
};
const s = {
    container: css `
    cursor: pointer;

    &:hover * {
      opacity: 0.7;
    }
  `,
    titleContainer: css `
    padding-left: 65px;
    &.active {
      padding-left: 45px;
    }
  `,
    title: css `
    line-height: 1.5em;
  `,
};
